export enum Equipment {
  Bench = "bank",
  Barbell = "straight_bar",
  EZBar = "ez_bar",
  Dumbbell = "dumbbells",
  Machine = "machines",
  Others = "others",
  Pulley = "pulley",
  OwnWeight = "lift_own_weight",
  Band = "tape",
  ElasticBand = "elastic_band",
}
